import { render, staticRenderFns } from "./CommissionTiers.vue?vue&type=template&id=507aa62a&scoped=true"
import script from "./CommissionTiers.vue?vue&type=script&lang=js"
export * from "./CommissionTiers.vue?vue&type=script&lang=js"
import style0 from "./CommissionTiers.vue?vue&type=style&index=0&id=507aa62a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507aa62a",
  null
  
)

export default component.exports